import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { currentLocalTime } from 'util/time_formatting'

import { makeGetParticipantsGroupedByStatus } from '../../../reduxes/slices/call_participants/selectors'
import { makeGetCurrentCallParticipant } from '../../../reduxes/slices/call_participants/selectors'
import { getCurrentTeammateHandle } from '../../../reduxes/slices/current/selectors'
import { makeGetTopicById } from '../../../reduxes/slices/topics/selectors'

export const useCallMetadata = (call) => {
  const currentTeammateHandle = useSelector(getCurrentTeammateHandle)
  const getCurrentCallParticipant = useMemo(makeGetCurrentCallParticipant, [])
  const currentMembersParticipant = useSelector((state) =>
    getCurrentCallParticipant(state, { call }),
  )

  const getParticipantsGroupedByStatus = useMemo(
    makeGetParticipantsGroupedByStatus,
    [],
  )
  const { onCall, wasOnCall } = useSelector((state) =>
    getParticipantsGroupedByStatus(state, call),
  )

  const getTopic = useMemo(makeGetTopicById, [])
  const topic = useSelector((state) => getTopic(state, call?.topic_id))

  return useMemo(() => {
    if (!call) {
      return {
        callData: {},
        localParticipantData: {},
      }
    }

    const isGroupCall =
      topic && topic.participants && topic.participants.length > 2
    const startTime =
      call.start_time && Date.now() - Date.parse(call.start_time)
    const duration =
      call.start_time &&
      call.end_time &&
      new Date(call.end_time) - new Date(call.start_time)
    const durationInSeconds = Math.round(duration / 1000)

    const isCaller = currentTeammateHandle === call.caller_handle
    const hasParticipated = currentMembersParticipant !== undefined

    // FIXME: use ianaTimeZone on User, or perhaps add column to Member
    // const ianaTimeZone = currentPerson && currentPerson.ianaTimeZone
    const ianaTimeZone = undefined

    const endTime = currentLocalTime(ianaTimeZone, call.end_time)

    return {
      callData: {
        isGroupCall,
        startTime,
        endTime,
        duration,
        durationInSeconds,
        peopleOnCall: onCall.map(
          ({ topicParticipant, contact }) =>
            contact?.display_email || topicParticipant.handle,
        ),
        peopleThatJoinedCall: wasOnCall.map(
          ({ topicParticipant, contact }) =>
            contact?.display_email || topicParticipant.handle,
        ),
      },
      localParticipantData: {
        isCaller,
        hasParticipated,
      },
    }
  }, [
    call,
    currentMembersParticipant,
    currentTeammateHandle,
    onCall,
    topic,
    wasOnCall,
  ])
}
